import { createAsyncThunk } from '@reduxjs/toolkit';
import { parseErrorData } from 'utils/service';
import { AppAsyncThunkConfig } from 'store/store';
import { NAMESPACE } from './helpers';
import { ServiceUserPatientProfileWeeklyReports } from 'services/user-patient-profile-weekly-reports';
import { selectWeeklyReportFilters } from './selectors';
import { WeeklyReportItem } from '../models';

export const actionWeeklyReportLoadData = createAsyncThunk<
  WeeklyReportItem[],
  void,
  AppAsyncThunkConfig
>(`${NAMESPACE}/loadData`, async (_, { getState }) => {
  try {
    const state = getState();

    const filters = selectWeeklyReportFilters(state);

    const data = await ServiceUserPatientProfileWeeklyReports.getWeeklyReports({
      done: filters.done,
      year: filters.year,
    })

    return data
  } catch (e: any) {
    throw parseErrorData(e);
  }
});
